/*
 * @Author: leventlei
 * @Date: 2024-01-14 09:06:55
 * @LastEditTime: 2024-12-22 12:38:02
 * @LastEditors: huasheng-c 957461792@qq.com
 * @Description:内容区头部
 * @FilePath: \IOT4CMS\src\layouts\baseLayout\header\index.tsx
 */
import React, { FC, useEffect, useState } from 'react'

import logoPNG from '@/assets/images/logo.png'
import { GlobalModelState } from '@/models/connect'
import moment from 'moment'
import {
	Dispatch,
	connect,
	dateSelectorType,
	pullDownMenuType,
	useLocation,
} from 'umi'
import UserContent from '../user'
import HeadBars from './components/HeadBars'
import ProjectSelector from './components/ProjectSelector'
import styles from './index.less'
interface HeaderContentProps {
	dispatch: Dispatch
	global: GlobalModelState
}

const HeaderContent: FC<HeaderContentProps> = ({ dispatch, global }) => {
	const location = useLocation()

	const [projectSelectValue, setProjectSelectValue] = useState<any>() //选择器的value
	const [areaSelectValue, setAreaSelectValue] = useState<any>() //选择器的value
	const [citySelectValue, setCitySelectValue] = useState<any>() //选择器的value
	const [instanceSelectValue, setInstanceSelectValue] = useState<any>() //选择器的value
	const [exhibitionSelectValue, setExhibitionSelectValue] = useState<any>() //选择器的value

	/* 页面头部是否需要项目下拉选择器 */
	const handleProjectSelectPage = () => {
		if (
			[
				'/propertyManagement',
				'/localOperationHome',
				'/guestRoomStatus',
				'/exhibitionManagement', // 展览管理
				'/propertyDevice', //设备列表
				'/propertyPersonnel', //人员管理
				'/propertyClean', //房间清洁
				'/iotInstance', //实例管理
				'/memberRightCenter', //邀请券管理
				'/commodityLibrary', //套餐-商品库
				'/operationWindow', //运营-运营视窗
			].includes(location.pathname) &&
			!global.showProjectSelect
		) {
			return true
		}
		return false
	}

	/* 页面头部是否需要实例下拉选择器 */
	const handleInstantiationSelectPage = () => {
		if (
			[
				'/propertyDevice', //设备列表
				'/propertyManagement', //物管运营首页
			].includes(location.pathname) &&
			!global.showProjectSelect
		) {
			return true
		}
		return false
	}

	/* 页面头部是否需要完整的区域、城市、项目选择器、时间范围选择器 */
	const handleHeadBarsPage = () => {
		if (
			[
				'/businessManagement',
				'/orderManagement',
				'/exhibitionOrderManagement', // 展览订单管理
			].includes(location.pathname) &&
			!global.showProjectSelect
		) {
			return true
		}
		return false
	}

	/* 页面头部是否需要展览下拉选择器 */
	const handleExhibitionSelectPage = () => {
		if (
			[
				'/exhibitionDynamic', // 展览动态
			].includes(location.pathname) &&
			!global.showProjectSelect
		) {
			return true
		}
		return false
	}

	/* 初始化页面顶部工能项 */
	useEffect(() => {
		if (
			handleProjectSelectPage() ||
			handleInstantiationSelectPage() ||
			handleHeadBarsPage() ||
			handleExhibitionSelectPage()
		) {
			setAreaSelectValue(null)
			setCitySelectValue(null)
			setInstanceSelectValue(null)
			dispatch({
				type: 'global/queryProjectMenu',
				callback: res => {
					console.log(res)
					setProjectSelectValue(
						Number(sessionStorage.getItem('_projectId')) !== 0
							? Number(sessionStorage.getItem('_projectId'))
							: res[0].value,
					)

					// dispatch({
					// 	type: 'global/save',
					// 	payload: {
					// 		// fixedDate: dateSelectorType.today, //默认今日
					// 		// dataValue:[
					// 		// 	moment(moment().format('YYYY-MM-DD'), 'YYYY/MM/DD'),
					// 		// 	moment(moment().format('YYYY-MM-DD'), 'YYYY/MM/DD'),
					// 		// ],//默认今日
					// 		// projectId:
					// 		// 	Number(sessionStorage.getItem('_projectId')) !== 0
					// 		// 		? Number(sessionStorage.getItem('_projectId'))
					// 		// 		: res[0].value, //  默认无项目id
					// 		// instanceId: null, //默认无实例id
					// 		areaId: null, //默认无地区id
					// 		cityId: null, //默认无城市id
					// 		projectOption: [...res],
					// 	},
					// })
				},
			})
			dispatch({
				type: 'global/queryProjectAreaMenu',
				callback: res => {},
			})

			// dispatch({
			// 	type: 'global/queryExhibitionDropdownList',
			// })
			// renderTime(dateSelectorType.today)
		}
	}, [location.pathname])

	/* 存在项目id时才能请求实例选项 */
	useEffect(() => {
		if (
			global.projectId !== '' &&
			global.projectId !== undefined &&
			global.projectId !== null &&
			handleInstantiationSelectPage()
		) {
			dispatch({
				type: 'global/queryInstantiationMenu',
				payload: {
					projectId: global.projectId,
					pageNumber: 1,
					pageSize: 1000,
				},
				callback: res => {
					if (res.length > 0) {
						setInstanceSelectValue(res[0].value)
						dispatch({
							type: 'global/save',
							payload: {
								instantiationOption: [...res],
								instanceId: res[0].value,
							},
						})
					} else {
						setInstanceSelectValue(null)
						dispatch({
							type: 'global/save',
							payload: {
								instantiationOption: [...res],
								instanceId: '',
							},
						})
					}
				},
			})
		}
	}, [global.projectOption, global.projectId])

	useEffect(() => {
		if (global.exhibitionOption.length > 0) {
			setExhibitionSelectValue(global.exhibitionOption[0].value)
		}
	}, [global.exhibitionOption])

	/* 监听项目切换 */
	const handleProjectSelectorChange = (value: number) => {
		console.log('value is', value)
		setProjectSelectValue(value)
		// setInstanceSelectValue(null)
		dispatch({
			type: 'global/save',
			payload: {
				projectId: value,
			},
		})
		sessionStorage.setItem('_projectId', value.toString())
	}

	/*监听区域选项*/
	const handleArea = (value: String) => {
		setAreaSelectValue(value)
		dispatch({
			type: 'global/queryProjectCityMenu',
			payload: {
				areaValue: value,
			},
		})
		dispatch({
			type: 'global/save',
			payload: {
				areaId: value,
			},
		})
	}

	/*监听城市选项*/
	const handleCity = (value: String) => {
		setCitySelectValue(value)
		dispatch({
			type: 'global/save',
			payload: {
				cityId: value,
			},
		})
	}

	/* 监听实例切换 */
	const handleInstanceChange = (value: number) => {
		setInstanceSelectValue(value)
		dispatch({
			type: 'global/save',
			payload: {
				instanceId: value,
			},
		})
	}

	/* 监听展览切换 */
	const handleExhibitionChange = (value: number) => {
		setExhibitionSelectValue(value)
		console.log('value is', value)
		dispatch({
			type: 'global/save',
			payload: {
				exhibitionId: value,
			},
		})
	}

	/* 时间选择框 */
	// const renderTime = type => {
	// 	let _dateValue
	// 	if (type === dateSelectorType.today) {
	// 		_dateValue = [
	// 			moment(moment().format('YYYY-MM-DD'), 'YYYY/MM/DD'),
	// 			moment(moment().format('YYYY-MM-DD'), 'YYYY/MM/DD'),
	// 		]
	// 	} else if (type === dateSelectorType.yesterday) {
	// 		_dateValue = [
	// 			moment(
	// 				moment()
	// 					.add(-1, 'd')
	// 					.format('YYYY-MM-DD'),
	// 				'YYYY/MM/DD',
	// 			),
	// 			moment(
	// 				moment()
	// 					.add(-1, 'd')
	// 					.format('YYYY-MM-DD'),
	// 				'YYYY/MM/DD',
	// 			),
	// 		]
	// 	} else if (type === dateSelectorType.sevenDays) {
	// 		_dateValue = [
	// 			moment(
	// 				moment()
	// 					.add(-7, 'd')
	// 					.format('YYYY-MM-DD'),
	// 				'YYYY/MM/DD',
	// 			),
	// 			moment(moment().format('YYYY-MM-DD'), 'YYYY/MM/DD'),
	// 		]
	// 	} else if (type === dateSelectorType.thirtyDays) {
	// 		_dateValue = [
	// 			moment(
	// 				moment()
	// 					.add(-30, 'd')
	// 					.format('YYYY-MM-DD'),
	// 				'YYYY/MM/DD',
	// 			),
	// 			moment(moment().format('YYYY-MM-DD'), 'YYYY/MM/DD'),
	// 		]
	// 	}
	// 	// setDateValue(_dateValue)

	// 	dispatch({
	// 		type: 'global/save',
	// 		payload: {
	// 			dateValue: [
	// 				_dateValue[0].format('YYYY-MM-DD'),
	// 				_dateValue[1].format('YYYY-MM-DD'),
	// 			],
	// 			fixedDate: type,
	// 		},
	// 	})
	// }
	const renderTime = type => {
		let _dateValue
		if (type === dateSelectorType.today) {
			_dateValue = [
				moment().format('YYYY-MM-DD'),
				moment().format('YYYY-MM-DD'),
			]
		} else if (type === dateSelectorType.yesterday) {
			_dateValue = [
				moment()
					.add(-1, 'd')
					.format('YYYY-MM-DD'),

				moment()
					.add(-1, 'd')
					.format('YYYY-MM-DD'),
			]
		} else if (type === dateSelectorType.sevenDays) {
			_dateValue = [
				moment()
					.add(-7, 'd')
					.format('YYYY-MM-DD'),
				moment().format('YYYY-MM-DD'),
			]
		} else if (type === dateSelectorType.thirtyDays) {
			_dateValue = [
				moment()
					.add(-30, 'd')
					.format('YYYY-MM-DD'),

				moment().format('YYYY-MM-DD'),
			]
		}
		dispatch({
			type: 'global/save',
			payload: {
				dateValue: _dateValue,
				fixedDate: type,
			},
		})
	}

	const onLogoClick = () => {
		dispatch({
			type: 'global/save',
			payload: {
				showProjectSelect: true,
			},
		})
	}

	return (
		<div className={styles.headerContent}>
			<div className={styles.headerContentLeft}>
				<img
					src={logoPNG}
					className={styles.logo}
					alt=""
					onClick={onLogoClick}
				/>
				{!global.hideHeader && (
					<>
						{handleProjectSelectPage() && (
							<ProjectSelector
								selectValueProps={projectSelectValue}
								handleSelectorChange={handleProjectSelectorChange}
								options={global.projectOption}
								placeholder={pullDownMenuType.projectOption}
							/>
						)}
						{handleInstantiationSelectPage() && (
							<ProjectSelector
								selectValueProps={instanceSelectValue}
								handleSelectorChange={handleInstanceChange}
								options={global.instantiationOption}
								placeholder={pullDownMenuType.instantiationOption}
							/>
						)}
						{handleExhibitionSelectPage() && (
							<ProjectSelector
								selectValueProps={exhibitionSelectValue}
								handleSelectorChange={handleExhibitionChange}
								options={global.exhibitionOption}
								placeholder={pullDownMenuType.exhibitionOption}
							/>
						)}
						{handleHeadBarsPage() && (
							<HeadBars
								projectSelectValue={projectSelectValue}
								areaSelectValue={areaSelectValue}
								citySelectValue={citySelectValue}
								handleSelectorChange={handleProjectSelectorChange}
								handleArea={handleArea}
								handleCity={handleCity}
								renderTime={renderTime}
							/>
						)}
					</>
				)}
			</div>
			<UserContent />
		</div>
	)
}

export default connect(({ global }: { global: GlobalModelState }) => ({
	global,
}))(HeaderContent)
